import React from "react";
import { withRouter } from "react-router-dom";
import withSnackbar from "../../util/withSnackbar";
import { injectIntl } from "react-intl";
import Button from "@mui/material/Button";
import { DATE_FORMAT, SNACKBAR_OPTIONS, TIMEOUT, Ultimate_URL } from "../../constants/CommonConstants";
import Header from "../CeHeader/Header";
import { LinearProgress } from "@mui/material";
import ChangePasswordDialog from "../CeHeader/ChangePasswordDialog";
import CeResetPasswordDialog from "./CeResetPasswordDialog";
import { errorHandle } from "../../Common/errorHandle";
import cognitoAuth from "../../util/Cognito";
import "./CeTop.css";
import moment from "moment";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { ThemeProvider } from "@mui/system";
import { StyledDataGrid } from "../Common/muiOverrideStyle";
import { FormattedMessage } from "react-intl";
import TextField from "@mui/material/TextField";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

class CeTop extends React.Component {
    constructor(props) {
        super(props);
        this.closeChangePasswordDialog = this.closeChangePasswordDialog.bind(this);
        this.state = {
            displayRequestButton: "block",
            showChangePassword: localStorage.getItem("isCeInitialLogin") ? JSON.parse(localStorage.getItem("isCeInitialLogin")) : false,
            userList: [],
            num_requests: 0,
            searchString: "",
            ceId: this.props.location.state.ceId,
            isProgress: false,
            searchBtnClickable: false,
            showCeResetPassword: false,
            showConfirmationDialog: false,
            isKMCE: false,
            originalUserList: [],
        };
    }

    componentDidMount() {
        let header = {
            Authorization: "",
        };

        this.setState({ isProgress: true });
        cognitoAuth
            .getAuthorizationToken()
            .then(
                (token) => {
                    header.Authorization = token;
                },
                (error) => {
                    this.setState({ isProgress: false });
                    throw error;
                }
            )
            .then(() => {
                const controller = new AbortController();
                const props = this;
                const timer = window.setTimeout(
                    errorHandle(function () {
                        controller.abort();
                        throw props;
                    }),
                    TIMEOUT
                );
                this.getCeAccountRole(header, controller);
                fetch(process.env.REACT_APP_CE_USER_LIST, {
                    method: "GET",
                    headers: header,
                    signal: controller.signal,
                })
                    .then((response) => {
                        window.clearTimeout(timer);
                        if (!response.ok) {
                            if (response.status === 408) {
                                // エラーメッセージ表示
                                this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_connection_error" }));
                            } else {
                                // エラーメッセージ表示
                                this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_get_error" }, { status: response.status }));
                                // ログイン画面に遷移させる
                                this.props.history.push({ pathname: "/" });
                            }
                        }
                        return response.json();
                    })
                    .then((res) => {
                        //add isVisible: true to all items in userList
                        let userList = res;

                        userList.forEach(function (user, index) {
                            user.isVisible = true;
                            user.id = index;
                            user.licenseList.forEach((obj) => {
                                if (obj.feature === "Ultimate SI") {
                                    user.ultimateLicense = { ...obj };
                                } else if (obj.feature === "JobManager") {
                                    user.jmLicense = { ...obj };
                                }
                            });
                        });

                        this.setState({
                            userList: userList,
                            originalUserList: userList,
                        });
                        return res;
                    })
                    .then((res) => {
                        let userCount = 0;
                        if (res.length === 0) {
                            this.setState({ isProgress: false });
                            return;
                        }
                        res.map((user) => {
                            // ユーザが所有するマシンの利用可否を取得する
                            let machineQs = new URLSearchParams({
                                userId: user.userId,
                            });
                            let userID = user.userId;
                            return fetch(process.env.REACT_APP_CE_USER_MACHINE_AVAILABILITY + `?${machineQs}`, {
                                method: "GET",
                                headers: header,
                                signal: controller.signal,
                                referrer: "about:client",
                                referrerPolicy: "no-referrer-when-downgrade",
                            }).then((responses) => {
                                window.clearTimeout(timer);
                                responses.json().then((result) => {
                                    let userList = this.state.userList;
                                    userList.forEach((user) => {
                                        if(user.jmLicense && !user.ultimateLicense){
                                            user.isAvailable = "jm";
                                        }else if(user.userId === userID){
                                            user.isAvailable = result.isAvailable;
                                        }
                                    });
                                    userCount++;
                                    if (userList.length === userCount) {
                                        this.setState({ isProgress: false });
                                    }
                                    this.setState({
                                        userList: userList,
                                        originalUserList: userList,
                                    });
                                });
                            });
                        });
                    });
            })
            .catch(() => {
                cognitoAuth.sessionTimeOut(this.props);
                this.setState({ isProgress: false });
            });
    }

    getCeAccountRole(header, controller) {
        let userQs = new URLSearchParams({
            ceId: this.state.ceId,
        });
        fetch(process.env.REACT_APP_CE_ROLE + `?${userQs}`, {
            method: "GET",
            headers: header,
            signal: controller.signal,
        })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 408) {
                        // エラーメッセージ表示
                        this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_connection_error" }));
                    } else {
                        // エラーメッセージ表示
                        this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_get_error" }, { status: response.status }));
                        // ログイン画面に遷移させる
                        this.props.history.push({ pathname: "/" });
                    }
                }
                return response.json();
            })
            .then((res) => {
                this.setState({
                    isKMCE: res ? true : false,
                });
            });
    }

    closeChangePasswordDialog() {
        localStorage.setItem("isCeInitialLogin", false);
        this.setState({
            showChangePassword: false,
        });
    }

    addCustomerAccount() {
        this.props.history.push({
            pathname: "/ce/top/addCustomer",
            state: {
                ceId: this.state.ceId,
            },
        });
    }

    onClickEditButton(userId) {
        this.props.history.push({
            pathname: "/ce/top/editCustomer",
            state: {
                ceId: this.state.ceId,
                userId: userId,
            },
        });
    }

    onClickOpenButton(userId) {
        try{
            let header = {
                Authorization: "",
                "Content-Type": "application/json",
            };
            cognitoAuth
            .getAuthorizationToken()
            .then(
                (token) => {
                    header.Authorization = token;
                },
                (error) => {
                    this.setState({ isProgress: false });
                    throw error;
                }
            )
            .then(() => {
                const controller = new AbortController();
                const props = this;
                const timer = window.setTimeout(
                    errorHandle(function () {
                        controller.abort();
                        throw props;
                    }),
                    TIMEOUT
                );
                this.getCeAccountRole(header, controller);
                fetch(process.env.REACT_APP_CE_UPDATE_CLONE_USER_LICENSE, {
                    method: "PUT",
                    headers: header,
                    signal: controller.signal,
                    body: JSON.stringify({
                        userId: userId,
                    }),
                })
                .then(() => {
                    window.clearTimeout(timer);
                })
            })
        }
        catch(err){
            console.log(err);
        }
        finally{
            this.setState({ userId: userId });
            localStorage.setItem("screen","all")
            window.open(Ultimate_URL[process.env.REACT_APP_BUILD_ENV]);
        }
    }

    handleSearchChange = (event) => {
        const searchString = event.target.value;

        const filteredRows = this.state.originalUserList.filter((user) => user.userId.includes(searchString));

        this.setState({
            userList: filteredRows,
        });
    };

    onClickRequestButton() {
        this.props.history.push({
            pathname: "/ce/top/requests",
        });
    }

    machineStatus(availability) {
        let icon = null;
        switch (availability) {
            case "jm":
                icon = <CheckCircleOutlineOutlinedIcon sx={{ fontSize: 30 }}/>;
                break;
            case true:
                icon = <CheckCircleOutlineOutlinedIcon sx={{ fontSize: 30 }}/>;
                break;
            case false:
                icon = <ErrorOutlineOutlinedIcon sx={{ color: "#d83737",fontSize: 30 }}/>;
                break;
            default:
                break;
        }
        return icon;
    }

    render() {
        const CustomCell = ({ value }) => {
            return <div className="cellTextOverFlow">{value}</div>;
        };

        const CustomerHeaderName = () => <FormattedMessage id="customers" />;

        const ScheduleHeaderName = () => <FormattedMessage id="jm_is_include_schedule" />;

        const UlHeaderName = () => <FormattedMessage id="ultimate_license_expires_on" />;

        const JmHeaderName = () => <FormattedMessage id="jm_license_expires_on" />;

        //MUI column definition
        const gridColumns = [
            {
                field: "isAvailable",
                headerName: "",
                sortable: false,
                width: 56,
                height: 40,
                renderCell: (params) => {
                    const isAvailable = params.value;
                    const iconPath = this.machineStatus(isAvailable);

                    return iconPath;
                },
            },
            {
                field: "userId",
                cellClassName: "wrap-cell",
                headerName: <CustomerHeaderName />,
                sortable: false,
                flex: 1,
                renderCell: (params) => {
                    return <CustomCell value={params.value} />;
                },
            },
            {
                field: "isIncludeSchedule",
                cellClassName: "schedule-cell",
                headerName: <ScheduleHeaderName />,
                sortable: false,
                flex: 1,
                renderCell: (params) => {
                    const value = params.value? "〇" : "×" 
                    return (
                        <div>{value}</div>
                    );
                },
            },
            {
                field: "jmLicense",
                headerName: <JmHeaderName />,
                sortable: false,
                flex: 1,
                renderCell: (params) => {
                    const obj = params.row.jmLicense ? params.row.jmLicense : null;

                    if (obj === null) {
                        return null;
                    }

                    return (
                        <div className={obj.isExpired ? "isExpiredLicense" : "isValidLicense"}>
                            {obj.endDate
                                ? moment(obj.endDate).format(DATE_FORMAT) + " " + "(" + obj.type + ")"
                                : this.props.intl.formatMessage({ id: "header_lms_never_expired" }) + " " + "(" + obj.type + ")"}
                        </div>
                    );
                },
            },
            {
                field: "ultimateLicense",
                headerName: <UlHeaderName />,
                sortable: false,
                flex: 1,
                renderCell: (params) => {
                    const obj = params.row.ultimateLicense ? params.row.ultimateLicense : null;

                    if (obj === null) {
                        return null;
                    }

                    return (
                        <div className={obj.isExpired ? "isExpiredLicense" : "isValidLicense"}>
                            {obj.endDate
                                ? moment(obj.endDate).format(DATE_FORMAT) + " " + "(" + obj.type + ")"
                                : this.props.intl.formatMessage({ id: "header_lms_never_expired" }) + " " + "(" + obj.type + ")"}
                        </div>
                    );
                },
            },
            {
                field: "status",
                headerName: "",
                disableSort: true,
                sortable: false,
                width: 316,
                height: 40,
                renderCell: (params) => (
                    <div className="imageButtonContainer">
                        <Button
                            variant="contained"
                            color="primary"
                            className={params.row.isAvailable &&  params.row.isAvailable !== "jm"? "customer-openbtn" : "customer-openbtn-disabled"}
                            fullWidth
                            onClick={() => this.onClickOpenButton(params.row.userId)}
                            disabled={!params.row.isAvailable || params.row.isAvailable === "jm"}
                        >
                            {this.props.intl.formatMessage({ id: "open" })}
                        </Button>
                        <div className="editPen" onClick={() => this.onClickEditButton(params.row.userId)}></div>
                        {params.value === "approved" ? (
                            <div
                                className="PwMail"
                                onClick={() => {
                                    this.setState({
                                        showCeResetPassword: true,
                                        showConfirmationDialog: true,
                                        selectedUser: params.row,
                                    });
                                }}
                            ></div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                ),
            },
        ];

        return (
            <div id="ceTop" className="variableFunctionLine">
                {this.state.isProgress ? <LinearProgress /> : ""}
                <Header showSubMenu={true} showThirdHeader={true} />
                <div className="mainContentsWrapper show">
                    <div className="mainContents flexReportContents">
                        <div className="title">{this.props.intl.formatMessage({ id: "ce_top_title" })}</div>
                        <div className="functions">
                            <div className="ce_mainContentTitle_list">
                                <span>
                                    {this.props.intl.formatMessage({
                                        id: "ce_customers_list_title",
                                    })}
                                </span>
                            </div>
                            <div className="switching">
                                <div className="searchFormStyles">
                                    <div className="searchForm">
                                        <img className="customer-icon search-btn" src="/assets/img/icon_search_24.svg" alt="icon_search" />
                                        <TextField
                                            className="searchTextField"
                                            type="search"
                                            size="small"
                                            variant="standard"
                                            placeholder={this.props.intl.formatMessage({ id: "ce_customers_list_search" })}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                            onChange={this.handleSearchChange}
                                        />
                                    </div>
                                </div>
                                {this.state.isKMCE ? (
                                    <Button className="request-btn" fullWidth onClick={() => this.onClickRequestButton()}>
                                        <img className="customer-icon request-btn" src={"/assets/img/img_CE_RequestCK.svg"} />
                                        {this.props.intl.formatMessage({ id: "ce_header_link_request" })}
                                        <span className={`circle ${this.state.num_requests > 0 ? "circleShow" : "circleHide"}`}> {this.state.num_requests} </span>
                                    </Button>
                                ) : (
                                    ""
                                )}
                                <Button className="add-customer-btn" fullWidth onClick={() => this.addCustomerAccount()}>
                                    <img className="customer-icon add-btn" src={"/assets/img/img_CE_add_account.svg"} />
                                    {this.props.intl.formatMessage({ id: "add_customers_account" })}
                                </Button>
                            </div>
                        </div>
                        <div className="ceCustomerTable">
                            { (
                                <Box
                                    sx={{
                                        height: "100%",
                                        width: "100%",
                                        border: "0px transparent",
                                        "& .MuiDataGrid-root .headercss": {
                                            backgroundColor: "#e6e6ea",
                                            borderRight: "1px solid #ccc",
                                            fontSize: "14px",
                                        },
                                        "& .MuiDataGrid-root .MuiDataGrid-columnHeader": {
                                            "&:focus": {
                                                outline: "solid #1976d2 0px",
                                            },
                                            ".MuiButtonBase-root": {
                                                width: "16px",
                                                margin: "0",
                                                padding: "0 !important",
                                            },
                                        },
                                        "& .MuiDataGrid-root ": {
                                            border: "1px solid transparent",
                                        },
                                        "& .innerList": {
                                            overflow: "hidden",
                                        },
                                        "& .lineHeight": {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            lineHeight: "1.3",
                                        },
                                        "& .MuiDataGrid-cellContent": {
                                            lineHeight: "1.3",
                                        },
                                    }}
                                >
                                    <div className="ceCustomerTableContent">
                                        <div className="ceDataGridTable">
                                            <ThemeProvider >
                                                {this.state.isProgress ? (
                                                    ""
                                                ) : (
                                                    <DataGrid
                                                        sx={StyledDataGrid}
                                                        rows={this.state.userList}
                                                        columns={gridColumns}
                                                        disableMultipleRowSelection={false}
                                                        pagination={false}
                                                        disableColumnMenu={true}
                                                        disableColumnReorder={true}
                                                        headerHeight={40}
                                                        localeText={{ noRowsLabel: this.props.intl.formatMessage({ id: "no_rows_label" }) }}
                                                    />
                                                )}
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Box>
                            ) }
                        </div>
                    </div>
                    <ChangePasswordDialog show={this.state.showChangePassword} handleClose={this.closeChangePasswordDialog} intl={this.props.intl} forceOpenFlag={true} />
                    <CeResetPasswordDialog
                        show={this.state.showCeResetPassword}
                        handleClose={() => {
                            this.setState({ showCeResetPassword: false });
                        }}
                        userId={this.state.selectedUser?.userId}
                        userLicenseList={this.state.selectedUser?.licenseList}
                        intlFormatMessage={this.props.intl.formatMessage}
                        openSnackbar={this.props.openSnackbar}
                        _this={this}
                        forceOpenFlag={true}
                        isIncludeSchedule={this.state.selectedUser?.isIncludeSchedule}
                    />
                </div>
            </div>
        );
    }
}

export default withSnackbar(withRouter(injectIntl(CeTop)), SNACKBAR_OPTIONS);
